<template>
  <div
    class="inline-block align-top"
    :class="slantStyles"
  >
    <slot />
  </div>
</template>

<script>
const validSlants = [
  '',
  'left-bottom',
  'left-top',
  'top-left',
  'top-right',
  'right-bottom',
  'right-top',
  'bottom-left',
  'bottom-right'
]

export default {
  // Name
  name: 'AppSlant',

  // Props
  props: {
    slant: {
      type: String,
      required: false,
      default: '',
      validator: (value) => validSlants.includes(value)
    },

    slantSm: {
      type: String,
      required: false,
      default: '',
      validator: (value) => validSlants.includes(value)
    },

    slantMd: {
      type: String,
      required: false,
      default: '',
      validator: (value) => validSlants.includes(value)
    },

    slantLg: {
      type: String,
      required: false,
      default: '',
      validator: (value) => validSlants.includes(value)
    }
  },

  // Computed
  computed: {
    slantStyles () {
      return {
        [`slant--${this.slant}`]: this.slant,
        [`slant--${this.slantSm}-sm`]: this.slantSm,
        [`slant--${this.slantMd}-md`]: this.slantMd,
        [`slant--${this.slantLg}-lg`]: this.slantLg
      }
    }
  }
}
</script>

<style scope lang="scss" src="@/styles/slants.scss"></style>
